import { Link } from "@chakra-ui/next-js";
import { Box, Button, Heading, VStack, Image, Flex } from "@chakra-ui/react";
import { Subheading } from "../Text";

export const SixthPanel = () => {
  return (
    <Flex
      bgColor="gray.900"
      alignItems="center"
      py={{ base: 8, lg: 16 }}
      flexWrap="wrap"
    >
      <VStack
        w={{ base: "100%", lg: "50%" }}
        mb={{ base: "48px", lg: "0px" }}
        gap={{ base: 4, md: 8, lg: 16 }}
      >
        <StoriesIntro />
        <Button
          href={"/stories"}
          as={Link}
          backgroundColor="yellow.500"
          color="gray.900"
          m="0px 80px"
        >
          Start journey
        </Button>
      </VStack>

      <Box w={{ base: "100%", lg: "50%" }}>
        <Box m="32px">
          <Image
            src="/homeShield.png"
            alt="A view looking out over a valley"
            h="370px"
            mx="auto"
          />
        </Box>
      </Box>
    </Flex>
  );
};

SixthPanel.displayName = "SwiperSlideSixthPanel";

const StoriesIntro = () => {
  return (
    <Box
      // bg="gray.900"
      // pb={{ base: "24px", lg: "72px" }}
      px={{ base: "40px", md: 8, lg: 16 }}
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <Heading
        textAlign="center"
        fontSize={{ base: "6xl", md: "8xl", lg: "6xl" }}
        mb={{ base: "18px", md: "48px" }}
      >
        <Box color="yellow.500">Stories</Box>
        <Box color="white" fontWeight="thin">
          from the road
        </Box>
      </Heading>

      <Subheading
        as="p"
        textAlign="center"
        fontSize={{ base: "lg", md: "2xl" }}
        color="white"
        w={{ base: "100%", md: "100%" }}
      >
        Learn more about what makes highway 3 unique, and get inspired for your
        next trip
      </Subheading>
    </Box>
  );
};
